<template>
  <!-- 活动-转盘活动配置-添加奖品 -->
  <div>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="添加物品" width="400px"
      @close="closeDialog">
      <el-form :model="dataForm" ref="dataForm" label-width="100px" size="small" :rules="replyRules">
        <el-form-item prop="origin_id" label="奖品信息">
          <AddGoods :prizeInfo="selectedData" @selectedData="getSelectedData"></AddGoods>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
import saveFile from '@/utils/saveFile'
import AddGoods from '@/components/goods/AddGoods.vue'

export default {
  components: {
    AddGoods,
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      imgType: 'prize',//上传图片的种类 奖品
      dataForm: {
        origin_id: '',
      },
      selectedData: undefined,//选择的物品数据
      replyRules: {//回复弹窗规则验证
        origin_id: [
          {
            required: true,
            message: '请选择物品',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.fromInfo) {
        this.dataForm = this.fromInfo
      }
    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      let params = this.dataForm
      if (this.type === 1) {
        postApiData(`upgrade_bottom`, params).then(res => {
          if (res.code) {
            this.$message.success(res.message)
            this.$emit('refresh')
            this.closeDialog()
          } else {
            this.$message.error(res.message)
          }
        }).finally(() => {
          this.buttonLoading = false
        })
      } else {
        patchApiData(`upgrade_bottom/${params.id}`, params).then(res => {
          if (res.code) {
            this.$message.success(res.message)
            this.$emit('refresh')
            this.closeDialog()
          } else {
            this.$message.error(res.message)
          }
        }).finally(() => {
          this.buttonLoading = false
        })
      }

    },
    //选择物品的反参数据
    getSelectedData(data) {
      let { id, name, image, second_name, rank, price } = data
      this.selectedData = { id, name, image, second_name, rank, price }
      this.dataForm.origin_id = data.id
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
.selected-debris-box {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 20px;

  img {
    width: 50px;
    margin-right: 10px;
  }

  .delete-btn {
    cursor: pointer;
    flex-shrink: 0;
    margin-left: 10px;
    color: rgba(255, 0, 0, 0.8);

    &:hover {
      color: rgba(255, 0, 0, 1);
    }
  }
}
</style>